// extracted by mini-css-extract-plugin
var _1 = "Scalable_container__48fcd";
var _2 = "Scalable_root__a7243";
export { _1 as "container", _2 as "root" }
